import { TextField } from '@mui/material';
import { useField } from 'formik';
import NumberFormat from 'react-number-format';

export const DateWrapper = ({ name, ...otherProps }: any) => {
  const [field, meta] = useField(name);

  const configTextfield = {
    ...field,
    ...otherProps,
  };

  if (meta && meta.touched && meta.error) {
    configTextfield.error = true;
    configTextfield.helperText = meta.error;
  }

  return (
    <NumberFormat
      customInput={TextField}
      variant="outlined"
      fullWidth
      {...configTextfield}
      autoComplete="off"
      placeholder="__/__/____"
      format="##/##/####"
    />
  );
};
